import React, { useRef, useState } from "react";
import AppLayout, {
  AppLayoutProps,
} from "@amzn/awsui-components-console/app-layout";
import { NonCancelableCustomEvent } from "@amzn/awsui-components-console";
import { useParams } from "react-router-dom";
import { Navigation } from "src/pages/commons";
import { URLS } from "src/components/constants/appConstants";
import { ToolsContent } from "./components/common-components";
import "../commons/common.styles.scss";
import { appLayoutAriaLabels } from "src/i18n-strings/app-layout";
import AppFixedFeeConfig from "src/components/fixedFeeConfigPage/fixed-fee-config-page";
import { useSettingsStore } from "src/stores/useSettingsStore";
import { resolveInitialPanelState } from "src/hooks/useInitialPanelState";

export function FixedFeeConfig() {
  const { id } = useParams();
  const { navPanelBehavior, toolsPanelBehavior } = useSettingsStore();
  const [navigationOpen, setNavigationOpen] = React.useState(
    resolveInitialPanelState(false, navPanelBehavior),
  );
  const appLayout = useRef<AppLayoutProps.Ref>(null);
  const [toolsOpen, setToolsOpen] = useState(
    resolveInitialPanelState(false, toolsPanelBehavior),
  );

  const onToolsChangeFn = ({
    detail,
  }: NonCancelableCustomEvent<AppLayoutProps.ChangeDetail>) => {
    setToolsOpen(detail.open);
  };
  return (
    <AppLayout
      disableContentPaddings
      content={<AppFixedFeeConfig key={id} />}
      navigation={<Navigation activeHref={URLS.GET_FIXED_FEE_CONFIG} />}
      navigationOpen={navigationOpen}
      onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
      tools={<ToolsContent />}
      toolsOpen={toolsOpen}
      onToolsChange={onToolsChangeFn}
      ariaLabels={appLayoutAriaLabels}
    />
  );
}
